/**
 * The `Idempotency-Key`s of the shipping actions of API v3: a repeat with the same key gets the response of the first
 * request instead of doing it again. A request gets the same key every time it is sent, until it succeeds: trying it
 * again after an answer that got lost (also from a dialog opened again) gets the first one's answer, instead of
 * printing the labels or reporting the manco twice. The API keeps only a success, so after a refusal the same key just
 * runs the request again. After a success the next one is a new request, also when it is the same.
 *
 * Kept for the page's lifetime (the API keeps a key for a day); only the last ones, a terminal tries few requests again.
 */
const keys = new Map<string, string>();

/** the most keys kept */
const maxKeys = 100;

const toRequest = (url: string, data: unknown): string => JSON.stringify([url, data]);

/** The key for a request (its path and body). */
export const idempotencyKeyFor = (url: string, data: unknown): string => {
    const request = toRequest(url, data);
    let key = keys.get(request);

    if (!key) {
        key = crypto.randomUUID();
        keys.set(request, key);

        if (keys.size > maxKeys) {
            keys.delete(keys.keys().next().value!);
        }
    }

    return key;
};

/** The request succeeded: the next one gets a new key. */
export const forgetIdempotencyKey = (url: string, data: unknown): void => {
    keys.delete(toRequest(url, data));
};
